function Universe() {
    return ( 
        <div className="container my-5 pt-5">

           <div className="row d-flex align-items-center gx-5 text-center">
                 <h1>The Zerodha Universe</h1>
                 <p> Extend your trading and investment experience even further with our partner platforms </p>
                

                <div className="col-4   p-3 mt-5"  >
                    <img src="media/images/smallcaseLogo.png" alt="img" className="img-fluid w-50 " />
                    <p text-muted text-small>Thematic investing platform that helps you invest in diversified baskets of stocks on ETFs.</p>
                </div>

                <div className="col-4  p-3 mt-5"  >
                     <img src="media/images/streakLogo.png" alt="img" className="img-fluid w-50" />
                    <p text-muted text-small>Thematic investing platform that helps you invest in diversified baskets of stocks on ETFs.</p>
                </div>

                <div className="col-4  p-3 mt-5"  >
                    <img src="media/images/zerodhaFundHouse.png" alt="img" className="img-fluid w-50" />
                    <p text-muted text-small>Thematic investing platform that helps you invest in diversified baskets of stocks on ETFs.</p>
                </div>
           

                <div className="col-4   p-3 mt-5"  >
                    <img src="media/images/sensibullLogo.svg" alt="img" className="img-fluid w-50" />
                    <p text-muted text-small>Thematic investing platform that helps you invest in diversified baskets of stocks on ETFs.</p>
                </div>

                <div className="col-4  p-3 mt-5"  >
                     <img src="media/images/dittoLogo.png" alt="img" className="img-fluid w-50" />
                    <p text-muted text-small>Thematic investing platform that helps you invest in diversified baskets of stocks on ETFs.</p>
                </div>

                <div className="col-4  p-3 mt-5"  >
                    <img src="media/images/smallcaseLogo.png" alt="img" className="img-fluid w-50" />
                    <p text-muted text-small>Thematic investing platform that helps you invest in diversified baskets of stocks on ETFs.</p>
                </div>
                  <button className='p-3 border-none fs-4 border-0 rounded-1 fs-4 my-5'  style={{width:"20%",margin:"auto",padding:"0.75rem",backgroundColor:"#387ed1",color:"white"}}>Sign up for free</button>

           </div>
        </div>
     );
}

export default Universe;